/* eslint-disable @typescript-eslint/no-empty-function */
import { EventData, EventViewData } from 'components/eventView/pages/eventData';
import { GuideQuery_guide } from 'graphql/query/__generated__/GuideQuery';
import { WorldMap_worldMap } from 'graphql/query/__generated__/WorldMap';
import { mergeGuideToEvent } from 'libs/utils/guide/mergeGuideToEvent';
import { createContext } from 'react';
import { IWorldMarker } from 'react-give-me-map';

export interface ICtxGuideAdmin {
    guide: GuideQuery_guide;
    map: WorldMap_worldMap;
    markers: IWorldMarker[];
    mergedEvent: EventViewData;
}

interface Props {
    children: React.ReactNode;
    guide: GuideQuery_guide;
    map: WorldMap_worldMap;
    markers: IWorldMarker[];
}

export const CtxGuideAdmin = createContext<ICtxGuideAdmin>(null);

export const CtxGuideAdminProvider = ({ children, guide, map, markers }: Props) => {
    const config = Object.values(EventData).find((e) => e.guideId === guide.guideId);
    const mergedEvent = mergeGuideToEvent(guide, config);

    return (
        <CtxGuideAdmin.Provider
            value={{
                guide: {
                    ...guide,
                    navigation: {
                        ...guide.navigation,
                        tabs: guide.navigation?.tabs ?? [],
                        drawer: guide.navigation?.drawer ?? [],
                        homepagePrimaryModule: guide.navigation?.homepagePrimaryModule ?? []
                    }
                },
                map,
                markers,
                mergedEvent
            }}
        >
            {children}
        </CtxGuideAdmin.Provider>
    );
};
